import React, { useEffect, useState } from "react";
import "./companypage.css";
import Stepper from "../../components/steper/Stepper";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateMember } from "../../redux/slices/memberSlice";
import Loader from "../../components/Loader/Loader";
import { ImageUp, Trash } from "lucide-react";
import {
  uploadPanFront,
  uploadPanBack,
  uploadAadharFront,
  uploadAadharBack,
  uploadCheque,
  uploadShopImage,
  uploadProfileImage,
} from "../../redux/slices/uploadSlice";
import { ShieldTick } from "iconsax-react";

const KYCDetailsForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);
  const previousData = location.state?.payload || {};
  const [memberId, setMemberId] = useState("");
  const [errors, setErrors] = useState({});
  const [uploadStatuspan, setUploadStatuspan] = useState(false);
  const [uploadStatuspan2, setUploadStatuspan2] = useState(false);
  const [uploadAadhar, setuploadAadhar] = useState(false);
  const [uploadAadhar2, setuploadAadhar2] = useState(false);
  const [chequeImg, setChequeImg] = useState(false);
  const [uploadShopImg, setUploadShopImg] = useState(false);
  const [uploProfileImg, setUploadProfileImg] = useState(false);

  const [kycData, setKycData] = useState({
    member_pan: "",
    member_aadhar: "",
    member_account: "",
    member_ifsc: "",
    member_id: "",
  });

  const [images, setImages] = useState({
    panFront: null,
    panBack: null,
    aadharFront: null,
    aadharBack: null,
    cheque: null,
    shop: null,
    profile: null,
    gst: null,
  });
  const [status, setStatus] = useState({
    member_pan_verify: 0,
    member_aadhar_verify: 0,
    member_bank_verify: 0,
  });

  // Validation functions remain the same
  const validatePAN = (pan) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan);
  const validateAadhar = (aadhar) => /^\d{12}$/.test(aadhar);
  const validateAccountNumber = (acc) => /^\d{9,18}$/.test(acc);
  const validateIFSC = (ifsc) =>
    /^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc.toUpperCase());

  const handleChange = (e) => {
    const { name, value } = e.target;
    setKycData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleImageChange = async (e, field) => {
    const file = e.target.files[0];
    if (file && memberId) {
      setImages((prev) => ({ ...prev, [field]: URL.createObjectURL(file) }));

      try {
        let resultAction;
        if (field === "panFront")
          resultAction = await dispatch(
            uploadPanFront({ member_id: memberId, file })
          );
        if (field === "panBack")
          resultAction = await dispatch(
            uploadPanBack({ member_id: memberId, file })
          );
        if (field === "aadharFront")
          resultAction = await dispatch(
            uploadAadharFront({ member_id: memberId, file })
          );
        if (field === "aadharBack")
          resultAction = await dispatch(
            uploadAadharBack({ member_id: memberId, file })
          );
        if (field === "cheque")
          resultAction = await dispatch(
            uploadCheque({ member_id: memberId, file })
          );
        if (field === "shop")
          resultAction = await dispatch(
            uploadShopImage({ member_id: memberId, file })
          );
        if (field === "profile")
          resultAction = await dispatch(
            uploadProfileImage({ member_id: memberId, file })
          );

        if (resultAction && resultAction.meta.requestStatus === "fulfilled") {
          if (field === "panFront") setUploadStatuspan(true);
          if (field === "panBack") setUploadStatuspan2(true);
          if (field === "aadharFront") setuploadAadhar(true);
          if (field === "aadharBack") setuploadAadhar2(true);
          if (field === "cheque") setChequeImg(true);
          if (field === "shop") setUploadShopImg(true);
          if (field === "profile") setUploadProfileImg(true);
        } else {
          console.error(`${field} Upload Failed:`, resultAction?.payload);
        }
      } catch (error) {
        console.error(`${field} Upload Error:`, error);
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!kycData.member_pan)
      newErrors.member_pan = "PAN card number is required";
    else if (!validatePAN(kycData.member_pan))
      newErrors.member_pan = "Invalid PAN number format (e.g., ABCDE1234F)";

    if (!kycData.member_aadhar)
      newErrors.member_aadhar = "Aadhaar number is required";
    else if (!validateAadhar(kycData.member_aadhar))
      newErrors.member_aadhar = "Invalid Aadhaar number (must be 12 digits)";

    if (!kycData.member_account)
      newErrors.member_account = "Account number is required";
    else if (!validateAccountNumber(kycData.member_account))
      newErrors.member_account = "Invalid account number (9-18 digits)";

    if (!kycData.member_ifsc) newErrors.member_ifsc = "IFSC code is required";
    else if (!validateIFSC(kycData.member_ifsc))
      newErrors.member_ifsc = "Invalid IFSC code format (e.g., ABCD0123456)";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const finalData = {
      ...previousData,
      ...kycData,
      member_id: memberId, // ✅ Force inject latest memberId here
    };

    try {
      await dispatch(updateMember(finalData)).unwrap();
      navigate("/successpage");
    } catch (err) {
      console.error("Registration failed:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setMemberId(parsedUser.member_id)
        console.log('ZZZZZZZZZZZZZZZZZZZZZ', parsedUser.member_id )
        setKycData((prev) => ({
          ...prev,
          member_id: parsedUser.member_id || "",
          member_pan: parsedUser.member_pan || "",
          member_aadhar: parsedUser.member_aadhar || "",
          member_account: parsedUser.member_account || "",
          member_ifsc: parsedUser.member_ifsc || "",
        }));
        setImages({
          panFront: parsedUser.member_pan_front_url || null,
          panBack: parsedUser.member_pan_back_url || null,
          aadharFront: parsedUser.member_aadhar_front_url || null,
          aadharBack: parsedUser.member_aadhar_back_url || null,
          cheque: parsedUser.member_cheque_url || null,
          shop: parsedUser.member_shop_photo_url || null,
          profile: parsedUser.member_profile_url || null,
          gst: parsedUser.member_gst || null,
        });
        setStatus({
          member_pan_verify: parsedUser.member_pan_verify,
          member_aadhar_verify: parsedUser.member_aadhar_verify,
          member_bank_verify: parsedUser.member_bank_verify,
        });
      } catch (err) {
        console.error("Error parsing user from localStorage:", err);
      }
    }
  }, []);

  const isVerified = (key) => status[key] === 1;

  return (
    <>
      {loading && <Loader />}
      <div className="stepper_root">
        <Stepper currentStep={2} />
      </div>
      <div className="kyc-container">
        <form className="kyc-form" onSubmit={handleSubmit}>
          {/* PAN Number */}
          <div className="form-group">
            <label>PAN Card Number </label>
            <input
              type="text"
              name="member_pan"
              placeholder="Enter PAN card number"
              value={kycData.member_pan}
              onChange={handleChange}
              disabled={isVerified("member_pan_verify")}
              className={
                isVerified("member_pan_verify") ? "verified-field" : ""
              }
              maxLength={10}
            />
            {errors.member_pan && (
              <span className="error-text">{errors.member_pan}</span>
            )}
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <p style={{ fontSize: "17px", fontWeight: "bold" }}>
              Upload PAN Image
            </p>
          </div>

          {/* PAN Front */}
          <div className="flex_track">
            <div className="upload-box">
              <label style={{ fontSize: "14px" }}> Front Side </label>
              <div className="image-preview">
                {images.panFront ? (
                  <img src={images.panFront} alt="Pan Front" />
                ) : (
                  <div>
                    <ImageUp size={24} color="#3D90D7" />
                    <span className="upload-text"> Upload Image</span>
                  </div>
                )}
              </div>
              <div className="upload-btn-align">
                {uploadStatuspan ? (
                  <div className="upload-status-align">
                    <div className="sector_succesfull">
                      <span>
                        {" "}
                        <ShieldTick size="22" color="#145a32" variant="Bold" />
                      </span>
                      <span className="txt_trck"> Upload Successful</span>
                    </div>
                    <div style={{ width: "6vw" }}></div>
                    <Trash
                      size={17}
                      color="#FF0B55"
                      onClick={() => {
                        setImages((prev) => ({ ...prev, panFront: null }));
                        setUploadStatuspan(false);
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, "panFront")}
                    />
                  </div>
                )}
              </div>

              {errors.panFront && (
                <span className="error-text">{errors.panFront}</span>
              )}
            </div>

            {/* PAN Back */}
            <div className="upload-box">
              <label>Back Side</label>
              <div className="image-preview">
                {images.panBack ? (
                  <img src={images.panBack} alt="Pan Back" />
                ) : (
                  <span>
                    <ImageUp size={24} color="#bdc3c7" /> Upload Image
                  </span>
                )}
              </div>
              <div className="upload-btn-align">
                {uploadStatuspan2 ? (
                  <div className="upload-status-align">
                    <div className="sector_succesfull">
                      <span>
                        {" "}
                        <ShieldTick size="22" color="#145a32" variant="Bold" />
                      </span>
                      <span className="txt_trck"> Upload Successful</span>
                    </div>
                    <div style={{ width: "6vw" }}></div>
                    <Trash
                      onClick={() => {
                        setImages((prev) => ({ ...prev, panBack: null }));
                        setUploadStatuspan2(false);
                      }}
                      size={17}
                      color="#FF0B55"
                    />
                  </div>
                ) : (
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, "panBack")}
                    />
                  </div>
                )}
              </div>

              {errors.panBack && (
                <span className="error-text">{errors.panBack}</span>
              )}
            </div>
          </div>

          {/* Aadhaar Number */}
          <div className="form-group" style={{ marginTop: "20px" }}>
            <label>Aadhaar Number</label>
            <input
              type="text"
              name="member_aadhar"
              placeholder="Enter Aadhaar number"
              value={kycData.member_aadhar}
              onChange={handleChange}
              onInput={(e) =>
                (e.target.value = e.target.value.replace(/\D/g, ""))
              } // ✅ Only digits
              maxLength={12}
              disabled={isVerified("member_aadhar_verify")}
              className={
                isVerified("member_aadhar_verify") ? "verified-field" : ""
              }
              // className={errors.member_aadhar ? "error-border" : ""}
            />

            {errors.member_aadhar && (
              <span className="error-text">{errors.member_aadhar}</span>
            )}
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <p style={{ fontSize: "17px", fontWeight: "bold" }}>
              Upload Aadhar Image
            </p>
          </div>

          <div className="flex_track">
            {/* Aadhar Front */}
            <div className="upload-box">
              <label>Aadhar Card Front </label>
              <div className="image-preview">
                {images.aadharFront ? (
                  <img src={images.aadharFront} alt="Aadhar Front" />
                ) : (
                  <span>
                    <ImageUp size={24} color="#bdc3c7" /> Upload Image
                  </span>
                )}
              </div>
              <div className="upload-btn-align">
                {uploadAadhar ? (
                  <div className="upload-status-align">
                    <div className="sector_succesfull">
                      <span>
                        {" "}
                        <ShieldTick size="22" color="#145a32" variant="Bold" />
                      </span>
                      <span className="txt_trck"> Upload Successful</span>
                    </div>
                    <div style={{ width: "6vw" }}></div>
                    <Trash
                      size={17}
                      color="#FF0B55"
                      onClick={() => {
                        setImages((prev) => ({ ...prev, aadharFront: null }));
                        setuploadAadhar(false);
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, "aadharFront")}
                    />
                  </div>
                )}
              </div>

              {errors.aadharFront && (
                <span className="error-text">{errors.aadharFront}</span>
              )}
            </div>

            {/* Aadhar Back */}
            <div className="upload-box">
              <label>Aadhar Card Back </label>
              <div className="image-preview">
                {images.aadharBack ? (
                  <img src={images.aadharBack} alt="Aadhar Back" />
                ) : (
                  <span>
                    <ImageUp size={24} color="#bdc3c7" /> Upload Image
                  </span>
                )}
              </div>

              <div className="upload-btn-align">
                {uploadAadhar2 ? (
                  <div className="upload-status-align">
                    <div className="sector_succesfull">
                      <span>
                        {" "}
                        <ShieldTick size="22" color="#145a32" variant="Bold" />
                      </span>
                      <span className="txt_trck"> Upload Successful</span>
                    </div>
                    <div style={{ width: "6vw" }}></div>
                    <Trash
                      size={17}
                      color="#FF0B55"
                      onClick={() => {
                        setImages((prev) => ({ ...prev, aadharBack: null }));
                        setuploadAadhar2(false);
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, "aadharBack")}
                    />
                  </div>
                )}
              </div>
              {errors.aadharBack && (
                <span className="error-text">{errors.aadharBack}</span>
              )}
            </div>
          </div>
          {/* CHEQUE */}
          {/* <div style={{ display: "flex", justifyContent: "center" }}>
            <p style={{ fontSize: "17px", fontWeight: "bold" }}>
              Upload  Cheque Image
            </p>
          </div> */}

          <div className="d-flex">
            <div className="upload-box">
              <label>Cheque Book Image </label>
              <div className="image-preview">
                {images.cheque ? (
                  <img src={images.cheque} alt="Cheque Img" />
                ) : (
                  <span>
                    <ImageUp size={24} color="#bdc3c7" /> Upload Image
                  </span>
                )}
              </div>
              <div className="upload-btn-align">
                {chequeImg ? (
                  <div className="upload-status-align">
                    <div className="sector_succesfull">
                      <span>
                        {" "}
                        <ShieldTick size="22" color="#145a32" variant="Bold" />
                      </span>
                      <span className="txt_trck"> Upload Successful</span>
                    </div>
                    <div style={{ width: "6vw" }}></div>
                    <Trash
                      size={17}
                      color="#FF0B55"
                      onClick={() => {
                        setImages((prev) => ({ ...prev, cheque: null }));
                        setChequeImg(false);
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, "cheque")}
                    />
                  </div>
                )}
              </div>

              {/* {errors.aadharFront && (
                <span className="error-text">{errors.aadharFront}</span>
              )} */}
            </div>

            <div className="upload-box">
              <label>Upload Shop Image</label>
              <div className="image-preview">
                {images.shop ? (
                  <img src={images.shop} alt="Shop Img" />
                ) : (
                  <span>
                    <ImageUp size={24} color="#bdc3c7" /> Upload Image
                  </span>
                )}
              </div>
              <div className="upload-btn-align">
                {uploadShopImg ? (
                  <div className="upload-status-align">
                    <div className="sector_succesfull">
                      <span>
                        {" "}
                        <ShieldTick size="22" color="#145a32" variant="Bold" />
                      </span>
                      <span className="txt_trck"> Upload Successful</span>
                    </div>
                    <div style={{ width: "6vw" }}></div>
                    <Trash
                      size={17}
                      color="#FF0B55"
                      onClick={() => {
                        setImages((prev) => ({ ...prev, shop: null }));
                        setUploadShopImg(false);
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, "shop")}
                    />
                  </div>
                )}
              </div>

              {/* {errors.aadharFront && (
                <span className="error-text">{errors.aadharFront}</span>
              )} */}
            </div>
          </div>

          <div className="upload-box">
            <label>Upload Profile Image</label>
            <div className="image-preview">
              {images.profile ? (
                <img src={images.profile} alt="profile Img" />
              ) : (
                <span>
                  <ImageUp size={24} color="#bdc3c7" /> Upload Image
                </span>
              )}
            </div>
            <div className="upload-btn-align">
              {uploProfileImg ? (
                <div className="upload-status-align">
                  <div className="sector_succesfull">
                    <span>
                      {" "}
                      <ShieldTick size="22" color="#145a32" variant="Bold" />
                    </span>
                    <span className="txt_trck"> Upload Successful</span>
                  </div>
                  <div style={{ width: "6vw" }}></div>
                  <Trash
                    size={17}
                    color="#FF0B55"
                    onClick={() => {
                      setImages((prev) => ({ ...prev, profile: null }));
                      setUploadProfileImg(false);
                    }}
                  />
                </div>
              ) : (
                <div>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageChange(e, "profile")}
                  />
                </div>
              )}
            </div>

            {/* {errors.aadharFront && (
                <span className="error-text">{errors.aadharFront}</span>
              )} */}
          </div>

          {/* GST */}
          {/* <div className="upload-box">
            <label>GST</label>
            <div className="image-preview">
              {images.gst ? (
                <img src={images.gst} alt="GST" />
              ) : (
                <span>
                  <ImageUp size={24} color="#bdc3c7" /> Upload Image
                </span>
              )}
            </div>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(e, "gst")}
            />
            {errors.gst && <span className="error-text">{errors.gst}</span>}
          </div> */}

          {/* Bank Details */}
          <h4>Bank Details</h4>
          <div className="form-group">
            <label>Account Number </label>
            <input
              type="text"
              name="member_account"
              placeholder="Enter account number"
              value={kycData.member_account}
              onChange={handleChange}
              // className={errors.member_account ? "error-border" : ""}
              disabled={isVerified("member_bank_verify")}
              className={
                isVerified("member_bank_verify") ? "verified-field" : ""
              }
              maxLength={12}
            />
            {errors.member_account && (
              <span className="error-text">{errors.member_account}</span>
            )}
          </div>

          <div className="form-group">
            <label>IFSC Code </label>
            <input
              type="text"
              name="member_ifsc"
              placeholder="Enter IFSC code"
              value={kycData.member_ifsc}
              onChange={handleChange}
              disabled={isVerified("member_bank_verify")}
              className={
                isVerified("member_bank_verify") ? "verified-field" : ""
              }
            />
            {errors.member_ifsc && (
              <span className="error-text">{errors.member_ifsc}</span>
            )}
          </div>

          <div className="form-btn">
            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Proceed"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default KYCDetailsForm;
